<!-- <pre>slides.length: {{ slides.length }}</pre> -->

@if (slides.length) {
<h1 class="d-none">
  Implementos - Respuestos para Camiones, Buses y Remolque.
</h1>
<div class="block-slideshow">
  <owl-carousel-o
    [options]="options"
    appOwlPreventClick
    [ngClass]="{ item: true }"
  >
    <ng-container *ngFor="let slide of slides; index as i">
      <ng-template carouselSlide [id]="slide.imageClassic">
        <!--  Start::imagen desktop -->
        <div
          class="slide_container hidden sm:block cursor-pointer"
          style="aspect-ratio: 10/3"
        >
          <a [href]="slide.buttonUrl" (click)="onClickBanner($event, i)">
            <img
              [ngSrc]="slide.imageClassic"
              [alt]="slide.alt"
              fill
              [attr.priority]="i === 0 ? '' : null"
            />
          </a>
        </div>
        <!--  End::imagen desktop -->
        <!-- Start::imagen mobile -->
        <div
          class="slide_container block lg:hidden"
          style="aspect-ratio: 138/139"
        >
          <a [href]="slide.buttonUrl" (click)="onClickBanner($event, i)">
            <img
              [ngSrc]="slide.imageMobile"
              [alt]="slide.alt"
              fill
              [attr.priority]="i === 0 ? '' : null"
            />
          </a>
        </div>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</div>
}
